// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"c45e2a83","453":"9d3b9b5d"}[chunkId] + ".chunk.js";
};